<template>
  <v-footer app color="white" dense class="noprint elevation-hb">
    <v-row>
      <v-col class="py-1">
        <span class="caption">Softwaresul &copy; 2019 - 2023</span>
      </v-col>
      <v-col class="py-1 text-right">
        <span class="caption">{{ env }}</span>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    env: `ENV: ${process.env.VUE_APP_TITLE} - v.${process.env.VUE_APP_VERSION} - API-URL: ${process.env.VUE_APP_BASE_API}`,
  }),
};
</script>

<style></style>
